import { render, staticRenderFns } from "./ModalAlertLeavePublish.vue?vue&type=template&id=65835990&"
import script from "./ModalAlertLeavePublish.vue?vue&type=script&lang=js&"
export * from "./ModalAlertLeavePublish.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertLeavePublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports